import { animatedAIIcon } from '@blocksuite/affine/components/icons';
import {
  ImageIcon,
  MakeItRealIcon,
  MindmapIcon,
  PenIcon,
  PresentationIcon,
} from '@blocksuite/icons/lit';
import { html } from 'lit';

export const AIPenIconWithAnimation = animatedAIIcon(PenIcon());
export const AIPresentationIconWithAnimation =
  animatedAIIcon(PresentationIcon());
export const AIMindMapIconWithAnimation = animatedAIIcon(MindmapIcon());
export const AIImageIconWithAnimation = animatedAIIcon(ImageIcon());
export const MakeItRealIconWithAnimation = animatedAIIcon(MakeItRealIcon());

export const AffineIcon = (color: string) =>
  html`<svg
    width="63"
    height="62"
    viewBox="0 0 63 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      style="filter: drop-shadow(0 4px 2px rgba(66, 65, 73, 0.1))
        drop-shadow(0 6px 4px rgba(66, 65, 73, 0.05));"
    >
      <rect
        x="9.5"
        y="3"
        width="44"
        height="44"
        rx="8"
        fill="var(--streamlain-v2-layer-white)"
      />
      <rect
        x="10"
        y="3.5"
        width="43"
        height="43"
        rx="7.5"
        stroke="var(--streamlain-v2-layer-insideBorder-border)"
      />
      <path
        d="M30.6764 17.5421C30.6296 17.1287 30.2801 16.8162 29.864 16.8158C29.448 16.8154 29.0978 17.1272 29.0501 17.5405C28.7401 20.2281 27.9366 22.118 26.6402 23.4143C25.3439 24.7106 23.454 25.5142 20.7664 25.8242C20.3531 25.8718 20.0413 26.222 20.0417 26.6381C20.0422 27.0541 20.3547 27.4037 20.7681 27.4505C23.4113 27.7499 25.3413 28.5531 26.6684 29.8562C27.9905 31.1544 28.8109 33.0439 29.0479 35.7126C29.0855 36.1353 29.4398 36.4591 29.8641 36.4587C30.2884 36.4582 30.642 36.1335 30.6786 35.7108C30.9058 33.0859 31.7254 31.1568 33.054 29.8281C34.3827 28.4994 36.3119 27.6798 38.9367 27.4526C39.3595 27.416 39.6841 27.0625 39.6846 26.6382C39.6851 26.2138 39.3612 25.8595 38.9386 25.822C36.2698 25.5849 34.3804 24.7646 33.0822 23.4425C31.779 22.1154 30.9758 20.1853 30.6764 17.5421Z"
        fill=${color}
      />
      <path
        d="M39.4552 13.8245C39.437 13.6637 39.3011 13.5422 39.1393 13.542C38.9775 13.5418 38.8413 13.6631 38.8228 13.8238C38.7022 14.869 38.3897 15.6039 37.8856 16.1081C37.3815 16.6122 36.6465 16.9247 35.6013 17.0452C35.4406 17.0638 35.3194 17.2 35.3195 17.3618C35.3197 17.5236 35.4412 17.6595 35.602 17.6777C36.6299 17.7941 37.3805 18.1065 37.8966 18.6133C38.4107 19.1181 38.7297 19.8529 38.8219 20.8908C38.8365 21.0551 38.9743 21.1811 39.1393 21.1809C39.3043 21.1807 39.4418 21.0544 39.4561 20.89C39.5444 19.8693 39.8632 19.119 40.3799 18.6023C40.8966 18.0856 41.6468 17.7669 42.6676 17.6785C42.832 17.6643 42.9582 17.5268 42.9584 17.3618C42.9586 17.1968 42.8327 17.059 42.6683 17.0444C41.6304 16.9522 40.8957 16.6332 40.3908 16.119C39.884 15.6029 39.5717 14.8524 39.4552 13.8245Z"
        fill=${color}
      />
    </g>
  </svg> `;

export const ChatSendIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="24" height="24" rx="4" fill="#A9A9AD" />
  <g clip-path="url(#clip0_7455_53584)">
    <path
      d="M18.7402 5.45305C18.7402 5.45305 20.2433 4.8669 20.1175 6.2903C20.0761 6.87646 19.7005 8.92818 19.408 11.147L18.4059 17.7205C18.4059 17.7205 18.3223 18.6835 17.5706 18.851C16.8192 19.0181 15.6918 18.2648 15.4829 18.0973C15.3157 17.9716 12.3513 16.0874 11.3074 15.1665C11.015 14.9151 10.6807 14.4129 11.3492 13.8267L15.7332 9.63969C16.2342 9.1375 16.7353 7.96519 14.6475 9.38859L8.8015 13.3659C8.8015 13.3659 8.13333 13.7849 6.88093 13.4081L4.16645 12.5705C4.16645 12.5705 3.16438 11.9425 4.87641 11.3146C9.05221 9.34681 14.1883 7.33725 18.7394 5.45305H18.7402Z"
      fill="white"
    />
  </g>
  <defs>
    <clipPath id="clip0_7455_53584">
      <rect width="20" height="20" fill="white" transform="translate(2 2)" />
    </clipPath>
  </defs>
</svg> `;

export const ChatAbortIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_12965_7241)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0833 11.9993C19.0833 15.9114 15.912 19.0827 12 19.0827C8.08798 19.0827 4.91667 15.9114 4.91667 11.9993C4.91667 8.08733 8.08798 4.91602 12 4.91602C15.912 4.91602 19.0833 8.08733 19.0833 11.9993ZM20.3333 11.9993C20.3333 16.6017 16.6024 20.3327 12 20.3327C7.39763 20.3327 3.66667 16.6017 3.66667 11.9993C3.66667 7.39698 7.39763 3.66602 12 3.66602C16.6024 3.66602 20.3333 7.39698 20.3333 11.9993ZM10.3333 8.66602C9.41286 8.66602 8.66667 9.41221 8.66667 10.3327V13.666C8.66667 14.5865 9.41286 15.3327 10.3333 15.3327H13.6667C14.5871 15.3327 15.3333 14.5865 15.3333 13.666V10.3327C15.3333 9.41221 14.5871 8.66602 13.6667 8.66602H10.3333Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_12965_7241">
      <rect width="20" height="20" fill="white" transform="translate(2 2)" />
    </clipPath>
  </defs>
</svg> `;
